<template>
  <div class="faiDetail">
    <van-nav-bar title="收银台" left-arrow @click-left="returnPage" />
    <div class="mainBox">
      <div>
        <van-cell-group>
          <div v-for="(item, index) in formMsg" :key="index">
            <!-- 描述信息 -->
            <van-cell
              v-if="
                item.type == 'info' &&
                item.isShow &&
                item.value != 'yearPrice' &&
                item.value != 'amount'
              "
              :title="item.label"
              :value="formData[item.value]"
            />
            <van-cell
              v-else-if="item.value == 'yearPrice' || item.value == 'amount'"
              :title="item.label"
              :value="formData[item.value]"
              :class="
                item.value == 'yearPrice' || item.value == 'amount' ? 'red' : ''
              "
            >
              <template #right-icon>
                <span style="color: #b3b3b3">元</span>
              </template>
            </van-cell>
            <div
              v-if="item.type == 'select' && item.isShow"
              class="customSelect"
              @click="showPicker = true"
            >
              <span>{{ item.label }}</span>
              <span>
                {{ formData[item.value] }}
                <van-icon name="arrow" color="#c0c0c0" />
              </span>
            </div>
          </div>
        </van-cell-group>
      </div>

      <div style="margin-top: 10px">
        <div class="phone">
          <span for>缴款人手机号</span>
          <input
            type="tel"
            :class="{ errorPhone: phoneState }"
            min="0"
            maxlength="11"
            v-model="formData.phone"
            placeholder
            @blur="confirmPhoneBlur"
          />
        </div>
        <div class="phone">
          <span>再次确认手机号</span>
          <input
            :class="{ errorPhone: phoneState }"
            type="tel"
            min="0"
            maxlength="11"
            v-model="formData.confirmPhone"
            placeholder
            @blur="confirmPhoneBlur"
          />
        </div>
      </div>
      <van-button
        type="info"
        size="large"
        @click="initPay"
        :disabled="disabledBtn"
        class="btn"
        >支付{{ formData.amount }}元</van-button
      >
    </div>

    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      class="funeralSelect"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <!-- <Foot
      v-if="list && list.bottomMessage && list.bottomMessage.length > 0"
      :list="list"
      style="padding: 0px 20px;"
    ></Foot>-->
    <div id="widget" />
  </div>
</template>

<script>
import { Field, Toast, Dialog } from "vant";
import Foot from "@/components/foot";
let loadedMineMapJs = false;
export default {
  components: {
    Foot,
  },
  data() {
    return {
      showD: false,
      formData: {},
      formMsg: [
        { type: "info", label: "逝者姓名", value: "aDecName", isShow: true },
        { type: "info", label: "寄存位置", value: "aPlaceCode", isShow: true },
        {
          type: "info",
          label: "另一个位置",
          value: "otherPlace",
          isShow: true,
        },
        { type: "info", label: "使用人", value: "userName", isShow: true },
        { type: "info", label: "联系人", value: "relationName", isShow: true },
        { type: "info", label: "有效期", value: "validity", isShow: true },
        { type: "info", label: "年单价", value: "yearPrice", isShow: true },
        {
          type: "info",
          label: "位置描述",
          value: "placeDescribe",
          isShow: true,
        },
        { type: "select", label: "请选择年限", value: "year", isShow: true },
        { type: "info", label: "缴费金额", value: "amount", isShow: true },
      ],
      showPicker: false,
      columns: [],
      list: [], //底部信息
      queryInfo: {},
      vde: "",
      disabledBtn: true,
      phoneState: false,
    };
  },
  created() {
    this.queryInfo = this.$route.query;
    this.getFootData();
    this.getData();
  },
  methods: {
    confirmPhoneBlur() {
      let { phone, confirmPhone } = this.formData;
      if (!!phone && !!confirmPhone) {
        if (phone == confirmPhone) {
          this.phoneState = false;
          this.disabledBtn = false;
        } else {
          this.phoneState = true;
          this.disabledBtn = true;
          Dialog.alert({
            title: "提示",
            message: "手机号不一致，请检查",
            getContainer: ".faiDetail",
          });
        }
      }
    },
    selectChange(val) {
      this.formData.year = val.target.value;
      this.formData.amount = (
        val.target.value * this.formData.yearPrice
      ).toFixed(2);
    },
    closeO() {
      this.showD = false;
    },
    // 返回上一页
    returnPage() {
      this.$router.go(-1);
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.queryInfo.deptId,
        type: 11,
      };
      this.request({
        url: "/systemManage/mobileGetMessage",
        method: "get",
        params: data,
      }).then((res) => {
        if ((res.data.code = 1000)) {
          this.list = res.data.result;
        }
      });
    },
    getData() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      this.columns = [];
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/funeral_pay/getFuneral",
        method: "post",
        params: this.queryInfo,
      }).then((res) => {
        Toast.clear();
        if (res.data.code == 1000) {
          this.formData = res.data.result;
          let allowYears = res.data.result.allowYear.split("#");
          allowYears.forEach((item, index) => {
            this.columns.push(item + "年");
            if (index == 0) {
              this.$set(
                this.formData,
                "amount",
                (item * this.formData.yearPrice).toFixed(2)
              );
            }
          });
          this.$set(this.formData, "year", this.columns[0]);
          // arrearage>0 隐藏年限，年单价
          if (Number(this.formData.arrearage) > 0) {
            this.formMsg.forEach((item) => {
              if (item.value == "yearPrice" || item.value == "year") {
                item.isShow = false
              }
              if (item.value == "amount") {
                item.label = "欠费金额(元)";
                this.$set(
                  this.formData,
                  "amount",
                  Number(this.formData.arrearage).toFixed(2)
                );
              }
            });
            // console.log(this.formData);
            // let sDate = new Date(this.formData.validity);
            // let eDate = new Date();
            // let result = "";
            // //获得各自的年、月、日
            // let sY = sDate.getFullYear();
            // let sM = sDate.getMonth() + 1;
            // let sD = sDate.getDate();
            // let eY = eDate.getFullYear();
            // let eM = eDate.getMonth() + 1;
            // let eD = eDate.getDate();
            // let yL = eY - sY;
            // let mL = eM - sM;
            // let dL = eD - sD;
            // if (dL < 0) {
            //   mL--;
            // }
            // if (mL < 0) {
            //   yL--;
            // }
            // if (yL > 0) {
            //   result = yL;
            // } else {
            //   result = 0;
            // }
            // if(result>=1){
            //   this.columns=[this.columns[1]];
            // }
          }
          if (this.formData.otherPlace == "") {
            this.formMsg.forEach((item) => {
              if (item.value == "otherPlace") {
                item.isShow = false;
              }
            });
          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.message,
            getContainer: ".faiDetail",
          }).then(() => {
            this.$router.go(-1);
          });

        }
      });
    },
    onConfirm(val) {
      this.formData.year = val;
      this.formData.amount = (
        val.split("年")[0] * this.formData.yearPrice
      ).toFixed(2);
      this.showPicker = false;
    },
    initPay() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      setTimeout(()=>{
        Toast.clear();
      },2000)
      let data = {
        deptId: this.queryInfo.deptId,
        deviceType: "phone",
        payAmt: this.formData.amount,
        isExist: this.formData.isExist,
        aDecName: this.formData.aDecName,
        aPlaceCode: this.formData.aPlaceCode,
        yearPrice:
          Number(this.formData.arrearage) > 0 ? "" : this.formData.yearPrice,
        year:
          Number(this.formData.arrearage) > 0
            ? ""
            : this.formData.year.split("年")[0],
        arrearage: this.formData.arrearage,
        id: this.formData.id,
        uId: this.formData.uId,
        type: 1,
        phone: this.formData.phone,
        confirmPhone: this.formData.confirmPhone,
        relationName: this.formData.relationName,
        checkId: this.formData.checkId,
      };
      this.disabledBtn = true;
      if (window.localStorage.getItem("payRouteBack")) {
        window.localStorage.removeItem("payRouteBack");
      }
      // 请求支付接口
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/funeral_pay/funeralPayInit",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else {
          Toast.clear();
          this.disabledBtn = false;
          Dialog.alert({
            title: "提示",
            message: res.data.message,
            getContainer: ".faiDetail",
          }).then(() => {});
        }
      });
    },
    asyncLoadJs(url) {
      var Q = require("q");
      return Q.Promise((resolve, reject) => {
        let srcArr = document.getElementsByTagName("script");
        let hasLoaded = false;
        for (let i = 0; i < srcArr.length; i++) {
          //判断当前js是否加载上
          hasLoaded = srcArr[i].src == url ? true : false;
        }
        if (hasLoaded) {
          resolve();
          return;
        }
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject();
        };
      });
    },
    otherPay(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no,
      };

      let that = this;
      const interval = setInterval(() => {
        if (loadedMineMapJs) {
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          // Toast.clear();
          that.disabledBtn = false;
        }
      }, 100);
    },
  },
};
</script>
<style lang="scss">
.faiDetail {
  .van-dialog__header {
    background: rgb(1, 87, 155) !important;
    color: #fff;
    padding: 10px 0 !important;
    font-weight: 600 !important;
  }
  .van-nav-bar__content {
    background: #00559d !important;
  }
  .van-nav-bar__title {
    color: #fff;
  }
  .van-nav-bar__arrow {
    color: #fff !important;
  }
}
.funeralSelect {
  .van-picker__confirm {
    font-size: 16px;
    color: #208fff;
    letter-spacing: 0;
    font-weight: 500;
  }
  .van-picker__cancel {
    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
  .van-picker-column__item {
    font-size: 18px;
    letter-spacing: 0;
    font-weight: 400;
  }
  .van-picker-column__item--selected {
    font-size: 20px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
  .van-picker__toolbar {
    margin-top: 10px;
  }
}
</style>
<style lang='scss' scoped>
// .errorPhone {
//   border: 1px solid #f56c6c !important;
// }
.phone {
  display: flex;
  height: 45px;
  width:100%;
  align-items: center;
  justify-content: space-between;
  // padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #eee;
  span {
    font-size: 0.37333rem;
    display: block;
    min-width: 110px;
    white-space: nowrap;
    overflow: hidden;
    display: block;
    margin-left: 20px;
  }
  input {
    // flex: 1;
    // margin-left: 10px;
    max-width: 200px;
    padding-right: 18px;
    letter-spacing: 0;
    height: 30px;
    border: 0;
    padding-left: 6px;
    border-radius: 4px;
    text-align: right;
    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    text-align: right;
    font-weight: 400;
    display: block;
  }
  input::placeholder {
    color: #c0c0c0;
    font-size: 13px;
  }
}
.customSelect {
  display: flex;
  padding: 0 0.53333rem;
  height: 45px;
  border-bottom: 1px solid #eee;
  align-items: center;
  justify-content: space-between;
  span {
    font-size: 0.37333rem;
  }
  select {
    height: 30px;
    outline: none;
    width: 75px;
    background: rgba(250, 250, 250, 1);
    border: 0.01rem solid rgba(204, 204, 204, 1);
    border-radius: 0.1rem;
  }
}
.faiDetail {
  background: #f5f5f5;
  height: 100vh;
  box-sizing: border-box;

  .btn {
    background: #00549d;
    border-radius: 22px;
    width: 80%;
    display: block;
    margin: 0 auto;
    border: 0 !important;
    height: 44px;
    line-height: 44px;
    font-weight: bold;
  }
  .van-dialog__header {
    background: rgb(1, 87, 155) !important;
    color: #fff;
    padding: 10px 0 !important;
    font-weight: 600 !important;
  }
  .van-cell {
    border-bottom: 0.01rem solid #eeeeee;
    padding: 11px 20px;
  }
}
.mainBox {
  // padding: 0px 15px;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 10px;
  > div {
    border-radius: 10px;
    background: #fff;
    margin: 10px 15px;
    overflow: hidden;
  }
  .van-cell__title {
    span {
      font-size: 16px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  .van-cell__value {
    span {
      font-size: 16px;
      color: #b3b3b3;
      letter-spacing: 0;
      text-align: right;
      font-weight: 400;
    }
  }
  .customSelect {
    span:nth-of-type(1) {
      font-size: 16px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }
    span:nth-of-type(2) {
      font-size: 16px;
      color: #464a4c;
      letter-spacing: 0;
      text-align: right;
      font-weight: 400;
    }
  }
  .phone {
    span {
      font-size: 16px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  .van-button {
    margin-top: 60px;
    margin-bottom: 10px;
  }

  .red {
    .van-cell__value {
      span {
        color: #ff7000 !important;
        font-weight: 600;
      }
    }
  }
}
</style>
